import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=d738713a"
import script from "./Direct.vue?vue&type=script&lang=js"
export * from "./Direct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports